import { AppFooter } from './AppFooter';

export const MarcomAppFooter = AppFooter;
